import React, { useState,useMemo, forwardRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Card_link.css';
import {  useNavigate } from 'react-router-dom';
import {
  Button,
  Form,
} from 'react-bootstrap';
import { get_all_cards } from '../../../../utils/talent_services';


const CAS_certification = forwardRef(({ certifyAction }) => {
    // --- Estado de filtros/orden/columnas ---
    const navigate = useNavigate();   
    const [attachedFile, setattachedFile] = useState(null);
   


    const handleFileChange = (e) => {
            const file = e.target.files[0];
            if (file) {
                setattachedFile(file);
            }
        };

    const checkcertifyAction = (e) => {
      if(!attachedFile){
        alert ("Please attach a file before certifying the channel.");
        return;
      }
      
         certifyAction(attachedFile)
    };
   



 
  
    // ---------- UI ----------
    return (
      <div className="container py-4">

        {/* Barra de búsqueda + menús */}
        <div className="d-flex gap-2 mb-3 flex-wrap">

              
                                                    <Form.Control
                                                             id="file-upload-input"
                                                             type="file"
                                                             className="d-none"
                                                             onChange={(e) => handleFileChange(e)}
                                                         />

                                                            {attachedFile ? (
                                                                  <div className="d-flex align-items-center mt-2 p-2 border rounded">
                                                                  <span className="me-auto">
                                                                      <strong>Adjunto:</strong> {attachedFile.name}
                                                                  </span>
                                                                  {/* Botón para eliminar el archivo adjunto */}
                                                                  <Button 
                                                                      variant="outline-danger" 
                                                                      size="sm" 
                                                                      onClick={() => setattachedFile(null)} 
                                                                      title="Quitar archivo"
                                                                  >
                                                                      <i className="bi bi-x-lg"></i>
                                                                  </Button>
                                                                  </div>
                                                              ):
                                                              (
                                                                     <Button 
                                                                          variant="outline-secondary" 
                                                                          onClick={() => document.getElementById('file-upload-input').click()} 
                                                                          title="Adjuntar evidencia"
                                                                      >
                                                                          <i className="bi bi-paperclip"> Adjuntar Certificado de CAS</i>
                                                                      
                                                                  

                                                                      
                                                                      </Button>
                                                              )}

                                                          <Button
                                                                                 variant="danger"
                                                                                 size="sm"
                                                                                 onClick={()=>{checkcertifyAction()}}
                                                                                 // Call the new save handler
                                                                             >
                                                                                 Certify this channnel
                                                                             </Button>
        </div>

      </div>
    );
});

export default CAS_certification;
